import { render } from "./ButtonRank2.vue?vue&type=template&id=6b9eb9e5&scoped=true"
import script from "./ButtonRank2.vue?vue&type=script&lang=js"
export * from "./ButtonRank2.vue?vue&type=script&lang=js"

import "./ButtonRank2.vue?vue&type=style&index=0&id=6b9eb9e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9eb9e5"]])

export default __exports__